angular.module('property-price-list')
    .controller('PropertyPriceListNotesController', function ($http, toastr, $scope, $rootScope, $uibModalInstance, data, PropertyPriceList) {
        this.$onInit = () => {
            this.item = data;
            this.form = {
                id: this.item.id,
                notes: this.item.notes,
                action: 'notes'
            }
        }
        this.cancel = () => $uibModalInstance.dismiss('Canceled');
        this.save = () => {
            return PropertyPriceList.action(this.form).$promise.then(result => {
                $rootScope.$broadcast('property-price-list.updated', result);
                toastr.success("Zapisano");
                $uibModalInstance.close(result);
            })
        };
    })
